import router from './router'
import useAboutUsStore from './store'
import AboutUsMessages from './localization'

export default {
  router,
  useAboutUsStore,
  localization: AboutUsMessages,
}
